function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30,12a1.9922,1.9922,0,0,0-.5117.0742L28.4331,11.019a3.8788,3.8788,0,0,0,0-4.038l1.0552-1.0552a2.0339,2.0339,0,1,0-1.4141-1.4141L27.019,5.5669a3.8788,3.8788,0,0,0-4.038,0L21.9258,4.5117a2.0339,2.0339,0,1,0-1.4141,1.4141L21.5669,6.981a3.8788,3.8788,0,0,0,0,4.038l-1.0552,1.0552a2.0339,2.0339,0,1,0,1.4141,1.4141l1.0552-1.0552a3.8788,3.8788,0,0,0,4.038,0l1.0552,1.0552A1.9957,1.9957,0,1,0,30,12ZM23,9a2,2,0,1,1,2,2A2.0025,2.0025,0,0,1,23,9Z"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  id: "_Transparent_Rectangle_",
  "data-name": "<Transparent Rectangle>",
  className: "cls-1",
  width: 32,
  height: 32
});

function SvgUserAccess24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccess24);
export default __webpack_public_path__ + "static/media/UserAccess24.6f77ce2d.svg";
export { ForwardRef as ReactComponent };